import { View } from "binder"
import { ExportViewModel } from "./export-viewModel"

export class ExportView extends View<ExportViewModel>{
    GetViewUniqueId(): string {
        return "V-6A180A26-AC29-4C55-8D28-257EBBF11A99"
    }
    loadHtml(): string {
        let element = require('./export.html').default;
        let style = require('./export.less');
        return element;
    }
    constructor() {
       super();
    }

    public set text(v: string) { this._text = v; } public get text(): string { return this._text;} private _text: string;
    
    close(){
        this.dataContext.close();
    }
}
